'use client';

import { useState } from 'react';
import type { MouseEvent } from 'react';
import { useLocale } from 'next-intl';

import LanguageIcon from '@mui/icons-material/Language';
import { Typography } from '@mui/material';

import { Button } from '../button/Button';
import { LanguageSelector } from '../languageSelector/LanguageSelector';

export type TAnchorEl = null | Element;
export type TMouseEventClick<TElement = HTMLButtonElement> = (e: MouseEvent<TElement>) => void;

export const LanguageSelectorButton = () => {
  const [anchorEl, setAnchorEl] = useState<TAnchorEl>(null);
  const locale = useLocale();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick: TMouseEventClick = (event) => {
    if (anchorEl) {
      handleClose();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  return (
    <>
      <Button handleClick={handleClick}>
        <LanguageIcon sx={{ marginRight: 2 }} />
        <Typography component="span" textAlign="center">
          {locale}
        </Typography>
      </Button>
      <LanguageSelector
        handleClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        currentLanguage={locale}
      />
    </>
  );
};
